import React, { useState, useEffect } from 'react'
import EVNew from './EV_NEW_PAGE/EVNew'
import EVNewMobile from './EV_NEW_PAGE/EVNewMobile'
import ArbNew from './ARB_NEW_PAGE/ArbNew'
import ArbNewMobile from './ARB_NEW_PAGE/ArbNewMobile'
import MiddlesNew from './MIDDLES_NEW_PAGE/MiddlesNew'
import MiddlesNewMobile from './MIDDLES_NEW_PAGE/MiddlesNewMobile'
import BonusNew from './BONUS_NEW_PAGE/BonusNew'
import BonusNewMobile from './BONUS_NEW_PAGE/BonusNewMobile'
import PickEm from './PICKEM_PAGE/PickEm'
import ODDS1 from './ODDS_PAGE/ODDS1'
import ODDS1Mobile from './ODDS_PAGE/ODDS1Mobile'
import PickEmMobile from './PICKEM_PAGE/PickEmMobile'
import BetTracker2 from './TRACKER_PAGE/TRACKER1'
import BetTracker2Mobile from './TRACKER_PAGE/TRACKER1_MOBILE'
import BettingCalculators from './CALC_PAGE/CALC1'
import BettingCalculatorsMobile from './CALC_PAGE/CALC1_mobile'
import Dashboard from './DASHBOARD/Dashboard'
import Education from './components/Education'
import EducationMobile from './components/Education_mobile'
import BookmakerList from './components/BookmakerList'
import BookmakerListMobile from './components/BookmakerList_mobile'
import AffiliatePage from './components/AffiliatePage'
import AdminPage from './components/AdminPage'
import RacingOdds from './RACING_PAGE/RacingOdds'
import RacingOddsMobile from './RACING_PAGE/RacingOddsMobile'
import HorseRacingBot from './components/HorseRacingBot'
import PropEV from './PROP_EV_PAGE/PropEV'
import PropEvMobile from './PROP_EV_PAGE/PropEvMobile'
import ProfilePage from './components/ProfilePage'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { AuthModal } from './components/AuthModal'
import WelcomeMobile from './components/WelcomeMobile'
import SimpleUpgradePrompt from './components/SimpleUpgradePrompt'
import PricingPage from './components/PricingPage'
import PreviewOverlay from './components/PreviewOverlay'
import { TIER_NAMES } from './config/subscriptions'
import { goToPricingPage, goToCustomerPortal } from './config/stripeUrls'

// SVG Icon Components
const NavIcon = ({ name, color = '#e2e8f0' }) => {
  const icons = {
    dashboard: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    ev: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
        <polyline points="17 6 23 6 23 12"/>
      </svg>
    ),
    arb: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="17 1 21 5 17 9"/>
        <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
        <polyline points="7 23 3 19 7 15"/>
        <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
      </svg>
    ),
    middles: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="12" r="6"/>
        <circle cx="12" cy="12" r="2"/>
      </svg>
    ),
    bonus: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 12 20 22 4 22 4 12"/>
        <rect x="2" y="7" width="20" height="5"/>
        <line x1="12" y1="22" x2="12" y2="7"/>
        <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
        <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
      </svg>
    ),
    odds: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <line x1="8" y1="21" x2="16" y2="21"/>
        <line x1="12" y1="17" x2="12" y2="21"/>
      </svg>
    ),
    pickem: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 11l3 3L22 4"/>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
    ),
    tracker: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
    education: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
        <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"/>
      </svg>
    ),
    calculators: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="2" width="16" height="20" rx="2"/>
        <line x1="8" y1="6" x2="16" y2="6"/>
        <line x1="8" y1="10" x2="8" y2="10"/>
        <line x1="12" y1="10" x2="12" y2="10"/>
        <line x1="16" y1="10" x2="16" y2="10"/>
        <line x1="8" y1="14" x2="8" y2="14"/>
        <line x1="12" y1="14" x2="12" y2="14"/>
        <line x1="16" y1="14" x2="16" y2="14"/>
        <line x1="8" y1="18" x2="8" y2="18"/>
        <line x1="12" y1="18" x2="16" y2="18"/>
      </svg>
    ),
    bookmakers: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"/>
        <line x1="8" y1="12" x2="21" y2="12"/>
        <line x1="8" y1="18" x2="21" y2="18"/>
        <line x1="3" y1="6" x2="3.01" y2="6"/>
        <line x1="3" y1="12" x2="3.01" y2="12"/>
        <line x1="3" y1="18" x2="3.01" y2="18"/>
      </svg>
    ),
    pricing: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
        <line x1="1" y1="10" x2="23" y2="10"/>
      </svg>
    ),
    affiliates: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
    settings: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
    ),
    lock: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    ),
    prop_ev: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
        <polyline points="16 11 18 13 22 9"/>
      </svg>
    ),
    racing: (
      <svg width="22" height="20" viewBox="0 0 64 40" fill={color}>
        <path d="M14 20 C14 16 18 14 24 14 L36 14 C40 14 42 12 45 9 L50 5 C52 4 54 4 55 5 L56 3 L57 6 C59 8 61 11 62 13 C62 15 60 15 58 14 L52 13 C49 15 47 18 46 21 C46 24 44 26 41 26 L26 27 C20 27 15 25 14 20 Z"/>
        <path d="M42 24 L52 29 L58 28 L59 30 L51 32 L39 27 Z"/>
        <path d="M37 26 L42 31 L47 33 L46 35 L40 33 L34 27 Z"/>
        <path d="M18 22 L8 29 L3 30 L3 32 L10 32 L22 25 Z"/>
        <path d="M24 25 L20 32 L22 36 L24 36 L23 32 L28 26 Z"/>
        <path d="M15 17 C10 15 5 17 2 22 C6 20 10 20 15 21 Z"/>
        <circle cx="40" cy="5.5" r="2.6"/>
        <path d="M30 13 C32 9 36 7.5 40 8.5 L41 10.5 C37 10.5 34 12 33 14 Z"/>
        <path d="M39 9.5 L47 10 L47 11.8 L39 11.5 Z"/>
      </svg>
    ),
    horse_bot: (
      <svg width="20" height="20" viewBox="0 0 512 512" fill={color}>
        <path d="M0 464V316.9C0 208.5 68.3 111.8 170.5 75.6L340.2 15.5C361.6 7.9 384 23.8 384 46.4c0 11-5.5 21.2-14.6 27.3L336 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H48c-26.5 0-48-21.5-48-48zM328 224c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"/>
      </svg>
    )
  }
  return icons[name] || null
}

// Custom hook for mobile detection
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobile
}

const routerStyles = {
  container: {
    width: '100vw',
    margin: 0,
    padding: 0,
    backgroundColor: '#010714',
    minHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex'
  },
  sidebar: {
    width: '56px',
    backgroundColor: '#010714',
    borderRight: '1px solid #1b2538',
    padding: '0',
    position: 'fixed',
    height: '100vh',
    overflowY: 'hidden',
    overflowX: 'hidden',
    zIndex: 800,
    transition: 'width 0.3s ease',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column'
  },
  sidebarExpanded: {
    width: '236px',
    backgroundColor: '#010714',
    borderRight: '1px solid #1b2538',
    padding: '0',
    position: 'fixed',
    height: '100vh',
    overflowY: 'hidden',
    overflowX: 'hidden',
    zIndex: 800,
    transition: 'width 0.3s ease',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column'
  },
  sidebarHeader: {
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 16px'
  },
  sidebarHeaderExpanded: {
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 20px',
    gap: '10px'
  },
  logo: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#f1f5f9',
    margin: 0,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    letterSpacing: '-0.02em'
  },
  logoExpanded: {
    fontSize: '21px',
    fontWeight: '700',
    color: '#f1f5f9',
    margin: 0,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    letterSpacing: '-0.02em'
  },
  subtitle: {
    fontSize: '14px',
    color: '#94a3b8',
    margin: '4px 0 0 0'
  },
  nav: {
    padding: '16px 0'
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 0',
    margin: '2px 8px',
    color: '#cbd5e1',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderRadius: '10px',
    fontSize: '18px',
    position: 'relative'
  },
  navItemExpanded: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 12px',
    margin: '2px 10px',
    color: '#cbd5e1',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderRadius: '10px',
    fontSize: '13px',
    fontWeight: '600',
    justifyContent: 'flex-start',
    letterSpacing: '0.01em'
  },
  navItemActive: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 0',
    margin: '2px 8px',
    color: '#60a5fa',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderRadius: '10px',
    backgroundColor: 'rgba(59, 130, 246, 0.12)',
    fontSize: '18px',
    position: 'relative'
  },
  navItemActiveExpanded: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 12px',
    margin: '2px 10px',
    color: '#60a5fa',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderRadius: '10px',
    backgroundColor: 'rgba(59, 130, 246, 0.12)',
    fontSize: '13px',
    fontWeight: '700',
    justifyContent: 'flex-start',
    letterSpacing: '0.01em'
  },
  navIcon: {
    width: '20px',
    height: '20px',
    fontSize: '18px'
  },
  content: {
    marginLeft: '56px',
    width: 'calc(100vw - 56px)',
    minHeight: '100vh',
    transition: 'margin-left 0.3s ease, width 0.3s ease'
  },
  contentExpanded: {
    marginLeft: '220px',
    width: 'calc(100vw - 220px)',
    minHeight: '100vh',
    transition: 'margin-left 0.3s ease, width 0.3s ease'
  },
  // Mobile-specific styles
  mobileContainer: {
    width: '100vw',
    margin: 0,
    padding: 0,
    backgroundColor: '#010714',
    minHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column'
  },
  mobileHeader: {
    backgroundColor: '#010714',
    borderBottom: '1px solid #1b2538',
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    height: '53px',
    boxSizing: 'border-box'
  },
  mobileContent: {
    marginTop: '53px',
    minHeight: 'calc(100vh - 53px)',
    width: '100%',
    paddingBottom: 'calc(80px + env(safe-area-inset-bottom, 6px))'
  },
  hamburgerMenu: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#f1f5f9',
    fontSize: '24px',
    cursor: 'pointer',
    padding: '8px'
  }
}

const NEW_BADGE_RELEASES = {
  prop_ev: '2026-04-30'
}

const isNewPage = (pageId) => {
  const releasedAt = NEW_BADGE_RELEASES[pageId]
  if (!releasedAt) return false
  const released = new Date(releasedAt).getTime()
  if (Number.isNaN(released)) return false
  return Date.now() - released < 7 * 24 * 60 * 60 * 1000
}

function PageRouterContent() {
  // Initialize currentPage from URL hash, fallback to dashboard
  const [currentPage, setCurrentPage] = useState(() => {
    const hash = window.location.hash
    // Don't set route if OAuth tokens are present (let Supabase process them first)
    if (hash.includes('access_token') || hash.includes('refresh_token')) {
      return 'dashboard' // Will be set properly after auth completes
    }
    const cleanHash = hash.replace('#/', '')
    return cleanHash || 'dashboard'
  })
  // Sidebar hover logic with localStorage
  const [manuallyLocked, setManuallyLocked] = useState(() => {
    const saved = localStorage.getItem('sidebar-locked')
    return saved === 'true'
  })
  const [resourcesOpen, setResourcesOpen] = useState(() => {
    const saved = localStorage.getItem('resources-open')
    return saved !== 'false'
  })
  const [isHovering, setIsHovering] = useState(false)
  // Locked = sidebar stays a collapsed rail (hover won't expand it).
  // Unlocked = rail expands on hover as an overlay; content never shifts.
  const isExpanded = !manuallyLocked && isHovering
  const [hoveredItem, setHoveredItem] = useState(null)
  const [showAuthModal, setShowAuthModal] = useState(false)
  const [gateAuthMode, setGateAuthMode] = useState('signin')
  const [showUpgradePrompt, setShowUpgradePrompt] = useState(false)
  const [showPreview, setShowPreview] = useState(false)
  const [previewFeature, setPreviewFeature] = useState('')
  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const { user, signOut, loading, subscriptionTier, isPastDue, hasAccess, isPasswordResetRequired, hadTrial } = useAuth()
  const isMobile = useIsMobile()

  // Returning logged-out mobile visitors who've already seen the welcome
  // carousel go straight to the sign-in modal (carousel stays behind it).
  // The flag is captured ONCE on first render — the carousel writes it on
  // mount, and child effects run before parent effects, so reading it inside
  // the effect would always see "seen" and skip the carousel (race).
  const [seenWelcome] = useState(() => localStorage.getItem('bc-welcome-seen') === 'true')
  useEffect(() => {
    if (!loading && !user && isMobile && seenWelcome) {
      setGateAuthMode('signin')
      setShowAuthModal(true)
    }
  }, [loading, user, isMobile, seenWelcome])

  // Update URL hash when page changes
  useEffect(() => {
    // Don't update hash if OAuth tokens are present (let Supabase process them first)
    if (window.location.hash.includes('access_token') || window.location.hash.includes('refresh_token')) {
      return
    }
    window.location.hash = `#/${currentPage}`
  }, [currentPage])

  // Listen for browser back/forward button
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#/', '')
      if (hash && hash !== currentPage) {
        setCurrentPage(hash)
      }
    }

    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [currentPage])

  // Check access when page or subscription changes
  useEffect(() => {
    if (loading || !user) return

    const currentPageConfig = pages.find(p => p.id === currentPage)
    if (!currentPageConfig) return

    // Check if user has access to current page
    if (!hasAccess(currentPageConfig.feature) && currentPageConfig.feature !== 'calculators') {
      setPreviewFeature(currentPageConfig.label)
      setShowPreview(true)
    } else {
      setShowPreview(false)
    }
    // pages is rebuilt each render; the effect's real triggers are already listed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, subscriptionTier, hasAccess, loading, user])

  // Listen for password recovery events
  React.useEffect(() => {
    const handlePasswordRecovery = () => {
      setShowAuthModal(true)
    }

    window.addEventListener('password-recovery', handlePasswordRecovery)
    return () => window.removeEventListener('password-recovery', handlePasswordRecovery)
  }, [])

  // Handle page navigation with access control
  const handlePageClick = React.useCallback((page) => {
    // Check if authentication is required
    if (page.requiresAuth && !user) {
      setShowAuthModal(true)
      return
    }

    // Always clear preview first
    setShowPreview(false)

    // Always allow navigation to page
    setCurrentPage(page.id)

    // Reset scroll position to top
    window.scrollTo(0, 0)

    // Show preview overlay if no access to this specific page
    if (!hasAccess(page.feature) && page.feature !== 'calculators') {
      setPreviewFeature(page.label)
      setShowPreview(true)
    }
  }, [user, hasAccess])

  // Dashboard navigation helper - avoids circular reference
  const handleDashboardNavigate = React.useCallback((pageId) => {
    const pageMap = {
      'ev': { id: 'ev', requiresAuth: true, feature: 'ev' },
      'arb': { id: 'arb', requiresAuth: true, feature: 'arb' },
      'middles': { id: 'middles', requiresAuth: true, feature: 'middles' },
      'bonus': { id: 'bonus', requiresAuth: true, feature: 'bonus' },
      'pickem': { id: 'pickem', requiresAuth: true, feature: 'pickem' },
      'prop_ev': { id: 'prop_ev', requiresAuth: true, feature: 'prop_ev' },
      'odds': { id: 'odds', requiresAuth: true, feature: 'odds' },
      'tracker': { id: 'tracker', requiresAuth: true, feature: 'tracker' },
      'education': { id: 'education', requiresAuth: true, feature: 'education' },
      'calculators': { id: 'calculators', requiresAuth: false, feature: 'calculators' },
      'bookmakers': { id: 'bookmakers', requiresAuth: true, feature: 'education' },
      'pricing': { id: 'pricing', requiresAuth: false, feature: 'calculators' },
      'affiliates': { id: 'affiliates', requiresAuth: false, feature: 'calculators' },
      'profile': { id: 'profile', requiresAuth: true, feature: 'calculators' },
      'dashboard': { id: 'dashboard', requiresAuth: false, feature: 'calculators' },
      'horse_bot': { id: 'horse_bot', requiresAuth: false, feature: 'calculators' },
      'racing': { id: 'racing', requiresAuth: true, feature: 'racing_odds' }
    }
    const page = pageMap[pageId]
    if (page) handlePageClick(page)
  }, [handlePageClick])

  // In-content page links (e.g. education lessons linking to the Bookmaker List)
  React.useEffect(() => {
    const onNavigate = (e) => handleDashboardNavigate(e.detail)
    window.addEventListener('bc-navigate', onNavigate)
    return () => window.removeEventListener('bc-navigate', onNavigate)
  }, [handleDashboardNavigate])

  const pages = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '🏠',
      description: 'Overview of tools, billing, and latest updates',
      feature: 'calculators',
      requiresAuth: false
    },
    {
      id: 'ev',
      label: 'Expected Value',
      icon: '📈',
      description: 'Positive expected value opportunities',
      feature: 'ev',
      requiresAuth: true
    },
    {
      id: 'arb',
      label: 'Arbitrage',
      icon: '⚖️',
      description: 'Arbitrage opportunities',
      feature: 'arb',
      requiresAuth: true
    },
    {
      id: 'middles',
      label: 'Middles',
      icon: '🎯',
      description: 'Middle betting opportunities',
      feature: 'middles',
      requiresAuth: true
    },
    {
      id: 'bonus',
      label: 'Bonus Converter',
      icon: '🎁',
      description: 'Convert bonus bets to guaranteed profit',
      feature: 'bonus',
      requiresAuth: true
    },
    {
      id: 'horse_bot',
      label: 'Horse Racing Bot',
      icon: '🐴',
      description: 'Real time +EV Horse Racing Selections',
      feature: 'calculators',
      requiresAuth: false
    },
    {
      id: 'racing',
      label: 'Racing Odds',
      icon: '⏱',
      description: 'Compare live racing odds across bookmakers',
      feature: 'racing_odds',
      requiresAuth: true
    },
    {
      id: 'odds',
      label: 'Sports Odds',
      icon: '📺',
      description: 'Compare live odds across all bookmakers',
      feature: 'odds',
      requiresAuth: true
    },
    {
      id: 'prop_ev',
      label: 'Prop Outliers',
      icon: '🏈',
      description: 'Player props priced against the market',
      feature: 'prop_ev',
      requiresAuth: true
    },
    {
      id: 'pickem',
      label: "Pick'em EV",
      icon: '✓',
      description: "+EV Pick'em legs with real time data",
      feature: 'pickem',
      requiresAuth: true
    },
    {
      id: 'tracker',
      label: 'Bet Tracker',
      icon: '📊',
      description: 'Track your betting performance',
      feature: 'tracker',
      requiresAuth: true
    },
    {
      id: 'education',
      label: 'Education',
      icon: '🎓',
      description: 'Learn profitable betting strategies',
      feature: 'education',
      requiresAuth: true
    },
    {
      id: 'calculators',
      label: 'Calculators',
      icon: '🧮',
      description: 'Arbitrage, EV & matched betting calculators',
      feature: 'calculators',
      requiresAuth: false
    },
    {
      id: 'bookmakers',
      label: 'Bookmaker List',
      icon: '📋',
      description: 'Complete list of Australian bookmakers',
      feature: 'education',
      requiresAuth: true
    },
    {
      id: 'pricing',
      label: 'Pricing',
      icon: '💳',
      description: 'View subscription plans',
      feature: 'calculators', // Always accessible
      requiresAuth: false
    },
    {
      id: 'affiliates',
      label: 'Affiliate Program',
      icon: '💰',
      description: 'Earn money referring customers',
      feature: 'calculators', // Always accessible
      requiresAuth: false
    }
  ]

  const navSections = [
    {
      label: null,
      items: ['dashboard']
    },
    {
      label: null,
      items: ['tracker']
    },
    {
      label: '+EV Tools',
      items: ['ev', 'pickem']
    },
    {
      label: 'Hedging',
      items: ['arb', 'middles']
    },
    {
      label: 'Promos',
      items: ['bonus', 'horse_bot']
    },
    {
      label: 'Research',
      items: ['odds', 'racing', 'prop_ev']
    }
  ]

  const resourcesItems = ['education', 'calculators', 'bookmakers', 'affiliates']

  const bottomNavItems = ['pricing']

  // Render all page components once - memoized to prevent unmounting on navigation/hover
  const allPageComponents = React.useMemo(() => {
    return (
      <>
        <div style={{display: currentPage === 'dashboard' ? 'block' : 'none'}}>
          <Dashboard onNavigate={handleDashboardNavigate} isVisible={currentPage === 'dashboard'} />
        </div>
        <div style={{display: currentPage === 'ev' ? 'block' : 'none'}}>
          {isMobile ? <EVNewMobile isVisible={currentPage === 'ev'} isPreview={showPreview && currentPage === 'ev'} /> : <EVNew isVisible={currentPage === 'ev'} isPreview={showPreview && currentPage === 'ev'} />}
        </div>
        <div style={{display: currentPage === 'arb' ? 'block' : 'none'}}>
          {isMobile ? <ArbNewMobile isVisible={currentPage === 'arb'} isPreview={showPreview && currentPage === 'arb'} /> : <ArbNew isVisible={currentPage === 'arb'} isPreview={showPreview && currentPage === 'arb'} />}
        </div>
        <div style={{display: currentPage === 'middles' ? 'block' : 'none'}}>
          {isMobile ? <MiddlesNewMobile isVisible={currentPage === 'middles'} isPreview={showPreview && currentPage === 'middles'} /> : <MiddlesNew isVisible={currentPage === 'middles'} isPreview={showPreview && currentPage === 'middles'} />}
        </div>
        <div style={{display: currentPage === 'bonus' ? 'block' : 'none'}}>
          {isMobile ? <BonusNewMobile isVisible={currentPage === 'bonus'} isPreview={showPreview && currentPage === 'bonus'} /> : <BonusNew isVisible={currentPage === 'bonus'} isPreview={showPreview && currentPage === 'bonus'} />}
        </div>
        <div style={{display: currentPage === 'prop_ev' ? 'block' : 'none'}}>
          {isMobile ? <PropEvMobile isVisible={currentPage === 'prop_ev'} isPreview={showPreview && currentPage === 'prop_ev'} onOpenInfo={() => window.dispatchEvent(new CustomEvent('bc-open-tour', { detail: 'prop_ev' }))} /> : <PropEV isVisible={currentPage === 'prop_ev'} isPreview={showPreview && currentPage === 'prop_ev'} />}
        </div>
        <div style={{display: currentPage === 'pickem' ? 'block' : 'none'}}>
          {isMobile ? <PickEmMobile isVisible={currentPage === 'pickem'} isPreview={showPreview && currentPage === 'pickem'} /> : <PickEm isVisible={currentPage === 'pickem'} isPreview={showPreview && currentPage === 'pickem'} />}
        </div>
        <div style={{display: currentPage === 'odds' ? 'block' : 'none'}}>
          {isMobile ? <ODDS1Mobile isVisible={currentPage === 'odds'} isPreview={showPreview && currentPage === 'odds'} /> : <ODDS1 isVisible={currentPage === 'odds'} isPreview={showPreview && currentPage === 'odds'} />}
        </div>
        <div style={{display: currentPage === 'tracker' ? 'block' : 'none'}}>
          {isMobile ? <BetTracker2Mobile isVisible={currentPage === 'tracker'} /> : <BetTracker2 isVisible={currentPage === 'tracker'} />}
        </div>
        <div style={{display: currentPage === 'education' ? 'block' : 'none'}}>
          {isMobile ? <EducationMobile /> : <Education />}
        </div>
        <div style={{display: currentPage === 'calculators' ? 'block' : 'none'}}>
          {isMobile ? <BettingCalculatorsMobile /> : <BettingCalculators />}
        </div>
        {currentPage === 'bookmakers' && (
          <div>
            {isMobile ? <BookmakerListMobile /> : <BookmakerList />}
          </div>
        )}
        <div style={{display: currentPage === 'pricing' ? 'block' : 'none'}}>
          <PricingPage />
        </div>
        <div style={{display: currentPage === 'affiliates' ? 'block' : 'none'}}>
          <AffiliatePage />
        </div>
        <div style={{display: currentPage === 'horse_bot' ? 'block' : 'none'}}>
          <HorseRacingBot isVisible={currentPage === 'horse_bot'} />
        </div>
        <div style={{display: currentPage === 'racing' ? 'block' : 'none'}}>
          {isMobile ? <RacingOddsMobile isVisible={currentPage === 'racing'} isPreview={showPreview && currentPage === 'racing'} /> : <RacingOdds isVisible={currentPage === 'racing'} isPreview={showPreview && currentPage === 'racing'} />}
        </div>
        <div style={{display: currentPage === 'profile' ? 'block' : 'none'}}>
          <ProfilePage />
        </div>
        {/* Unlinked admin route (#/admin); the page itself gates on the admin
            account and the DB returns nothing to anyone else via RLS */}
        {currentPage === 'admin' && <AdminPage />}
      </>
    )
  }, [currentPage, isMobile, handleDashboardNavigate, showPreview])

  // Show loading while checking auth
  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#010714', gap: '20px' }}>
        <style>{`
          @keyframes bc-spin { to { transform: rotate(360deg); } }
        `}</style>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src="https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/BC_LOGO_200x200.png" alt="Bookie Charity" style={{ width: '36px', height: '36px', borderRadius: '9px' }} />
          <span style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: '800', fontSize: '18px', color: '#f1f5f9', letterSpacing: '-0.4px' }}>Bookie Charity</span>
        </div>
        <div style={{ width: '24px', height: '24px', borderRadius: '50%', border: '2.5px solid #1b2538', borderTopColor: '#3b82f6', animation: 'bc-spin 0.75s linear infinite' }} />
      </div>
    )
  }

  // Show clean login screen if not authenticated.
  // Mobile gets the app-style welcome carousel as the front door; the auth
  // modal opens over it (closable — dismissing returns to the carousel).
  // Desktop keeps the unclosable AuthModal wall with the features panel.
  if (!user) {
    if (isMobile) {
      return (
        <>
          <WelcomeMobile onAuth={(mode) => { setGateAuthMode(mode); setShowAuthModal(true) }} />
          {(showAuthModal || isPasswordResetRequired) && (
            <AuthModal
              isOpen={true}
              initialMode={gateAuthMode}
              onClose={() => setShowAuthModal(false)}
            />
          )}
        </>
      )
    }
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#010714'
      }}>
        <AuthModal
          isOpen={true}
          onClose={() => {}} // Can't close - must login
        />
      </div>
    )
  }

  // Handle viewing plans - redirect to Stripe pricing page
  const handleViewPlans = () => {
    setShowUpgradePrompt(false)
    goToPricingPage()
  }

  // Mobile layout component
  const renderMobileLayout = () => {

    return (
      <div style={routerStyles.mobileContainer}>
        {/* Mobile Header */}
        <div style={routerStyles.mobileHeader}>
          {/* Logo + page title */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img
              src="https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/BC_LOGO_200x200.png"
              alt="Logo"
              style={{ height: '32px', width: '32px', borderRadius: '6px' }}
            />
            <span style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: '700', fontSize: '15.5px', color: '#f1f5f9', letterSpacing: '0.01em' }}>
              {currentPage === 'dashboard' ? 'Bookie Charity' : {
                ev: 'Positive Expected Value',
                arb: 'Arbitrage',
                middles: 'Middles',
                bonus: 'Bonus Converter',
                odds: 'Sports Odds',
                horse_bot: 'Horse Racing Bot',
                racing: 'Racing Odds',
                pickem: "Pick'em EV",
                prop_ev: 'Prop Outliers',
                tracker: 'Bet Tracker',
                education: 'Education',
                calculators: 'Calculators',
                bookmakers: 'Bookmakers',
                affiliates: 'Affiliate Program',
                pricing: 'Pricing',
                profile: 'Account',
                admin: 'Admin'
              }[currentPage] || 'Bookie Charity'}
            </span>
            {currentPage === 'prop_ev' && (
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('bc-open-tour', { detail: 'prop_ev' }))}
                style={{ background: 'rgba(59,130,246,0.1)', border: '1.5px solid #2d4a7a', color: '#60a5fa', borderRadius: '50%', width: '19px', height: '19px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}>
                ?
              </button>
            )}
            {currentPage === 'ev' && (
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('bc-open-tour', { detail: 'ev' }))}
                style={{ background: 'rgba(59,130,246,0.1)', border: '1.5px solid #2d4a7a', color: '#60a5fa', borderRadius: '50%', width: '19px', height: '19px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}>
                ?
              </button>
            )}
            {currentPage === 'pickem' && (
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('bc-open-tour', { detail: 'pickem' }))}
                style={{ background: 'rgba(59,130,246,0.1)', border: '1.5px solid #2d4a7a', color: '#60a5fa', borderRadius: '50%', width: '19px', height: '19px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}>
                ?
              </button>
            )}
            {currentPage === 'arb' && (
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('bc-open-tour', { detail: 'arb' }))}
                style={{ background: 'rgba(59,130,246,0.1)', border: '1.5px solid #2d4a7a', color: '#60a5fa', borderRadius: '50%', width: '19px', height: '19px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}>
                ?
              </button>
            )}
            {currentPage === 'middles' && (
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('bc-open-tour', { detail: 'middles' }))}
                style={{ background: 'rgba(59,130,246,0.1)', border: '1.5px solid #2d4a7a', color: '#60a5fa', borderRadius: '50%', width: '19px', height: '19px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}>
                ?
              </button>
            )}
            {currentPage === 'horse_bot' && (
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('bc-open-tour', { detail: 'horse_bot' }))}
                style={{ background: 'rgba(59,130,246,0.1)', border: '1.5px solid #2d4a7a', color: '#60a5fa', borderRadius: '50%', width: '19px', height: '19px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}>
                ?
              </button>
            )}
            {currentPage === 'bonus' && (
              <button
                onClick={() => window.dispatchEvent(new CustomEvent('bc-open-tour', { detail: 'bonus' }))}
                style={{ background: 'rgba(59,130,246,0.1)', border: '1.5px solid #2d4a7a', color: '#60a5fa', borderRadius: '50%', width: '19px', height: '19px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}>
                ?
              </button>
            )}
          </div>
          {/* Right: account icon or sign in */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {user ? (
              <button
                onClick={() => {
                  setCurrentPage('profile')
                  setShowMobileMenu(false)
                }}
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '8px'
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </button>
            ) : (
              <button
                onClick={() => setShowAuthModal(true)}
                style={{
                  padding: '6px 14px',
                  backgroundColor: '#2563eb',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: '600'
                }}
              >
                Sign In
              </button>
            )}
          </div>
        </div>

        {/* Mobile Content */}
        <div style={routerStyles.mobileContent}>
          <div style={{ filter: (showPreview && currentPage !== 'ev' && currentPage !== 'odds' && currentPage !== 'arb' && currentPage !== 'middles' && currentPage !== 'bonus' && currentPage !== 'pickem' && currentPage !== 'racing' && currentPage !== 'prop_ev' && currentPage !== 'education' && currentPage !== 'bookmakers') ? 'blur(8px)' : 'none', transition: 'filter 0.2s ease', pointerEvents: (showPreview && currentPage !== 'ev' && currentPage !== 'odds' && currentPage !== 'arb' && currentPage !== 'middles' && currentPage !== 'bonus' && currentPage !== 'pickem' && currentPage !== 'racing' && currentPage !== 'prop_ev' && currentPage !== 'education' && currentPage !== 'bookmakers') ? 'none' : 'auto' }}>
            {allPageComponents}
          </div>
        </div>

        {/* Preview Overlay */}
        {showPreview && currentPage !== 'ev' && currentPage !== 'odds' && currentPage !== 'arb' && currentPage !== 'middles' && currentPage !== 'bonus' && currentPage !== 'pickem' && currentPage !== 'racing' && currentPage !== 'prop_ev' && currentPage !== 'education' && currentPage !== 'bookmakers' && (
          <PreviewOverlay
            featureName={previewFeature}
            hadTrial={hadTrial}
            onGotoPricing={() => {
              setShowPreview(false)
              setCurrentPage('pricing')
            }}
            onClose={() => {
              setShowPreview(false)
              setCurrentPage('dashboard')
            }}
          />
        )}

        {/* Bottom Tab Bar — a floating frosted-glass bar: translucent page
            navy, strong blur so content scrolling under it reads as depth,
            a hairline in light and a lit top edge, like the glass buttons. */}
        <div style={{
          position: 'fixed',
          bottom: 'calc(8px + env(safe-area-inset-bottom, 0px))',
          left: '10px',
          right: '10px',
          height: '56px',
          backgroundColor: 'rgba(8, 14, 27, 0.72)',
          backdropFilter: 'blur(20px) saturate(160%)',
          WebkitBackdropFilter: 'blur(20px) saturate(160%)',
          border: '1px solid rgba(148, 163, 184, 0.14)',
          borderRadius: '18px',
          display: 'flex',
          alignItems: 'center',
          zIndex: 1000,
          boxSizing: 'border-box',
          padding: '5px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.06)'
        }}>
          {[
            { id: 'dashboard', label: 'Home', icon: 'dashboard' },
            { id: 'ev', label: 'EV', icon: 'ev' },
            { id: 'arb', label: 'Arb', icon: 'arb' },
            { id: 'tracker', label: 'Tracker', icon: 'tracker' },
            { id: '__more__', label: 'More', icon: '__more__' }
          ].map(tab => {
            const morePages = ['middles', 'bonus', 'odds', 'racing', 'horse_bot', 'prop_ev', 'pickem', 'education', 'calculators', 'bookmakers', 'affiliates', 'pricing', 'profile']
            const isActive = tab.id !== '__more__' ? currentPage === tab.id : showMobileMenu || morePages.includes(currentPage)
            const iconColor = isActive ? '#60a5fa' : '#64748b'
            const labelColor = isActive ? '#e4e9f0' : '#7a8aa3'
            return (
              <div
                key={tab.id}
                onClick={() => {
                  if (tab.id === '__more__') {
                    setShowMobileMenu(prev => !prev)
                  } else {
                    setShowMobileMenu(false)
                    handleDashboardNavigate(tab.id)
                  }
                }}
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '3px',
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  borderRadius: '13px',
                  padding: '3px 10px',
                  // Active tab: a blue-tinted glass pill inside the bar.
                  backgroundColor: isActive ? 'rgba(59, 130, 246, 0.14)' : 'transparent',
                  border: isActive ? '1px solid rgba(96, 165, 250, 0.22)' : '1px solid transparent',
                  boxShadow: isActive ? 'inset 0 1px 0 rgba(147, 197, 253, 0.08)' : 'none'
                }}
              >
                {tab.icon === '__more__' ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="5" cy="12" r="1.8" fill={iconColor}/>
                    <circle cx="12" cy="12" r="1.8" fill={iconColor}/>
                    <circle cx="19" cy="12" r="1.8" fill={iconColor}/>
                  </svg>
                ) : (
                  <NavIcon name={tab.icon} color={iconColor} />
                )}
                <span style={{ fontSize: '10px', fontWeight: isActive ? '600' : '500', letterSpacing: '0.2px', color: labelColor, fontFamily: "'Geist', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>
                  {tab.label}
                </span>
              </div>
            )
          })}
        </div>

        {/* Floor cover — fades content out below the floating bar rather than
            letting it show through the gap; page colour, not a slab. */}
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: 'calc(36px + env(safe-area-inset-bottom, 0px))',
          background: 'linear-gradient(to top, #010714 0%, #010714 30%, rgba(1, 7, 20, 0) 100%)',
          pointerEvents: 'none',
          zIndex: 999
        }} />

        {/* More Sheet — slide up from bottom */}
        <style>{`
          @keyframes sheetSlideUp {
            from { transform: translateY(100%); }
            to { transform: translateY(0); }
          }
          @keyframes sheetFadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}</style>
        {showMobileMenu && (
          <>
            {/* Backdrop */}
            <div
              onClick={() => setShowMobileMenu(false)}
              style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(1, 4, 12, 0.66)', backdropFilter: 'blur(2px)', WebkitBackdropFilter: 'blur(2px)',
                zIndex: 1001,
                animation: 'sheetFadeIn 0.2s ease'
              }}
            />
            {/* Sheet */}
            <div style={{
              position: 'fixed',
              bottom: 'calc(72px + env(safe-area-inset-bottom, 0px))',
              left: 0,
              right: 0,
              backgroundColor: '#080e1b',
              borderRadius: '20px 20px 0 0',
              border: '1px solid #1b2438',
              borderBottom: 'none',
              zIndex: 1002,
              animation: 'sheetSlideUp 0.25s cubic-bezier(0.32,0.72,0,1)',
              maxHeight: 'calc(100vh - 130px)',
              display: 'flex',
              flexDirection: 'column'
            }}>
              {/* Drag handle */}
              <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 6px', flexShrink: 0 }}>
                <div style={{ width: '36px', height: '4px', backgroundColor: '#2b3a57', borderRadius: '2px' }} />
              </div>

              {/* Scrollable: Tools + Resources */}
              <div style={{ flex: 1, overflowY: 'auto', padding: '0px 16px 12px' }}>

                {/* Tool groups — mirrors the desktop sidebar sections */}
                {[
                  { label: '+EV Tools', items: [
                    { id: 'pickem', label: "Pick'em EV", icon: 'pickem' },
                  ]},
                  { label: 'Hedging', items: [
                    { id: 'middles', label: 'Middles', icon: 'middles' },
                  ]},
                  { label: 'Promos', items: [
                    { id: 'bonus', label: 'Bonus Converter', icon: 'bonus' },
                    { id: 'horse_bot', label: 'Horse Racing Bot', icon: 'horse_bot' },
                  ]},
                  { label: 'Research', items: [
                    { id: 'odds', label: 'Sports Odds', icon: 'odds' },
                    { id: 'racing', label: 'Racing Odds', icon: 'racing' },
                    { id: 'prop_ev', label: 'Prop Outliers', icon: 'prop_ev' },
                  ]},
                ].map(group => (
                <div key={group.label} style={{ marginBottom: '16px' }}>
                  <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", fontSize: '10.5px', fontWeight: '600', color: '#64748b', letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: '8px' }}>{group.label}</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '6px' }}>
                    {group.items.map(item => {
                      const active = currentPage === item.id
                      return (
                        <div key={item.id} onClick={() => { handleDashboardNavigate(item.id); setShowMobileMenu(false) }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: '10px',
                            padding: '11px 14px',
                            borderRadius: '12px',
                            backgroundColor: active ? 'rgba(59,130,246,0.12)' : 'rgba(255,255,255,0.03)',
                            border: `1px solid ${active ? 'rgba(59,130,246,0.35)' : 'transparent'}`,
                            cursor: 'pointer'
                          }}>
                          <NavIcon name={item.icon} color={active ? '#3b82f6' : '#94a3b8'} />
                          <span style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", fontSize: '13.5px', fontWeight: '500', letterSpacing: '-0.006em', color: active ? '#3b82f6' : '#cbd5e1', lineHeight: '1.2', flex: 1 }}>{item.label}</span>
                          {isNewPage(item.id) && (
                            <span style={{
                              fontSize: '9px',
                              fontWeight: '800',
                              letterSpacing: '0.08em',
                              color: '#ffffff',
                              background: 'linear-gradient(135deg, #10b981 0%, #06b6d4 100%)',
                              padding: '2px 6px',
                              borderRadius: '999px',
                              textTransform: 'uppercase',
                              lineHeight: 1,
                              border: '1px solid rgba(255,255,255,0.18)',
                              flexShrink: 0
                            }}>NEW</span>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
                ))}

                {/* Resources grid */}
                <div>
                  <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", fontSize: '10.5px', fontWeight: '600', color: '#64748b', letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: '8px' }}>Resources</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                    {[
                      { id: 'education', label: 'Education', icon: 'education' },
                      { id: 'calculators', label: 'Calculators', icon: 'calculators' },
                      { id: 'bookmakers', label: 'Bookmakers', icon: 'bookmakers' },
                      { id: 'affiliates', label: 'Affiliates', icon: 'affiliates' },
                      { id: 'pricing', label: 'Plans & Pricing', icon: 'pricing' },
                    ].map(item => {
                      const active = currentPage === item.id
                      return (
                        <div key={item.id} onClick={() => { handleDashboardNavigate(item.id); setShowMobileMenu(false) }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: '10px',
                            padding: '11px 14px',
                            borderRadius: '12px',
                            backgroundColor: active ? 'rgba(59,130,246,0.12)' : 'rgba(255,255,255,0.03)',
                            border: `1px solid ${active ? 'rgba(59,130,246,0.35)' : 'transparent'}`,
                            cursor: 'pointer'
                          }}>
                          <NavIcon name={item.icon} color={active ? '#3b82f6' : '#94a3b8'} />
                          <span style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", fontSize: '13.5px', fontWeight: '500', letterSpacing: '-0.006em', color: active ? '#3b82f6' : '#cbd5e1', lineHeight: '1.2' }}>{item.label}</span>
                        </div>
                      )
                    })}
                  </div>
                </div>

              </div>

              {/* Sticky Account Section — always visible */}
              <div style={{ borderTop: '1px solid #1b2538', flexShrink: 0, padding: '8px 0 4px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 16px' }}>
                  {/* Plan badge */}
                  {user && (
                    <div
                      onClick={() => { subscriptionTier === 'free' ? setCurrentPage('pricing') : goToCustomerPortal(); setShowMobileMenu(false) }}
                      style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px', padding: '0 12px', height: '42px', backgroundColor: 'rgba(255,255,255,0.03)', borderRadius: '10px', cursor: 'pointer' }}
                    >
                      <div style={{ width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0,
                        backgroundColor: subscriptionTier === 'free' ? '#64748b' : subscriptionTier === 'sports' ? '#60a5fa' : subscriptionTier === 'horse_racing' ? '#a78bfa' : '#34d399'
                      }} />
                      <span style={{ fontSize: '13px', fontWeight: '600', color: '#e2e8f0', flex: 1 }}>{TIER_NAMES[subscriptionTier] || 'Free Plan'}</span>
                      {subscriptionTier === 'free' ? (
                        <span style={{ fontSize: '11px', fontWeight: '600', color: '#fff', backgroundColor: '#2563eb', padding: '3px 8px', borderRadius: '6px', flexShrink: 0 }}>
                          Upgrade
                        </span>
                      ) : (
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="9 18 15 12 9 6"/>
                        </svg>
                      )}
                    </div>
                  )}
                  {/* Profile */}
                  {user && (
                    <div onClick={() => { setCurrentPage('profile'); setShowMobileMenu(false) }}
                      style={{ width: '42px', height: '42px', borderRadius: '10px', backgroundColor: 'rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                        <circle cx="12" cy="7" r="4"/>
                      </svg>
                    </div>
                  )}
                  {/* Sign Out / Sign In */}
                  {user ? (
                    <div onClick={() => { signOut(); setShowMobileMenu(false) }}
                      style={{ width: '42px', height: '42px', borderRadius: '10px', backgroundColor: 'rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                        <polyline points="16 17 21 12 16 7"/>
                        <line x1="21" y1="12" x2="9" y2="12"/>
                      </svg>
                    </div>
                  ) : (
                    <button onClick={() => { setShowAuthModal(true); setShowMobileMenu(false) }}
                      style={{ flex: 1, padding: '10px', backgroundColor: '#2563eb', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
                      Sign In
                    </button>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

      {/* EV Info Modal */}

      {/* Prop Outliers Info Modal */}

      {/* Pick'em Info Modal */}

      {/* Arb Info Modal */}

      {/* Middles Info Modal */}

      {/* Bonus Info Modal */}

      </div>
    )
  }

  // Desktop layout (your existing layout)
  const renderDesktopLayout = () => (
    <div style={routerStyles.container}>
      <style>{`
        /* Webkit browsers (Chrome, Safari, Edge) */
        .sidebar-container::-webkit-scrollbar,
        .sidebar-container div::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }

        /* Firefox */
        .sidebar-container,
        .sidebar-container div {
          scrollbar-width: none;
        }

        /* Sidebar pin tooltips — open below the button (header sits at the
           top of the viewport, so the default above-anchor would clip) */
        .sidebar-pin-tip[data-tooltip]::after {
          bottom: auto;
          top: calc(100% + 7px);
        }
        .sidebar-pin-tip-right[data-tooltip]::after {
          left: auto;
          right: 0;
          transform: none;
        }
      `}</style>
      <div
        className="sidebar-container"
        style={{
          ...(isExpanded ? routerStyles.sidebarExpanded : routerStyles.sidebar),
          boxShadow: isExpanded ? '12px 0 40px rgba(0, 0, 0, 0.55)' : 'none'
        }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div style={isExpanded ? routerStyles.sidebarHeaderExpanded : routerStyles.sidebarHeader}>
          <img
            src="https://nfoqikkzbosxfylfstbz.supabase.co/storage/v1/object/public/images/BC_LOGO_200x200.png"
            alt="Logo"
            style={{ width: '32px', height: '32px', borderRadius: '6px', flexShrink: 0 }}
          />
          <div style={{
            opacity: isExpanded ? 1 : 0,
            maxWidth: isExpanded ? '160px' : '0',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            transition: 'opacity 0.3s ease, max-width 0.3s ease',
            fontSize: '17px',
            fontWeight: '800',
            color: '#f1f5f9',
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            letterSpacing: '-0.02em'
          }}>
            Bookie Charity
          </div>
          <button
            onClick={() => {
              setManuallyLocked(true)
              localStorage.setItem('sidebar-locked', 'true')
            }}
            data-tooltip="Lock sidebar closed"
            className="sidebar-pin-tip sidebar-pin-tip-right"
            aria-label="Lock sidebar closed"
            style={{
              marginLeft: isExpanded ? 'auto' : 0,
              marginRight: isExpanded ? '-8px' : 0,
              width: isExpanded ? '24px' : '0px',
              height: '24px',
              padding: 0,
              border: 'none',
              borderRadius: '7px',
              background: 'transparent',
              color: '#5b6678',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              opacity: isExpanded ? 1 : 0,
              overflow: isExpanded ? 'visible' : 'hidden',
              flexShrink: 0,
              pointerEvents: isExpanded ? 'auto' : 'none',
              transition: 'opacity 0.3s ease, width 0.3s ease, background 0.2s ease, color 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(148, 163, 184, 0.08)'
              e.currentTarget.style.color = '#f1f5f9'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent'
              e.currentTarget.style.color = '#5b6678'
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'rotate(45deg)', flexShrink: 0 }}>
              <line x1="12" y1="17" x2="12" y2="22"/>
              <path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>
            </svg>
          </button>
        </div>

        {/* Unlock control — only exists on the locked rail, since the header
            pin is unreachable when hover-expand is disabled */}
        {manuallyLocked && (
          <button
            onClick={() => {
              setManuallyLocked(false)
              localStorage.setItem('sidebar-locked', 'false')
            }}
            data-tooltip="Unlock"
            className="sidebar-pin-tip"
            aria-label="Unlock sidebar"
            style={{
              margin: '0 auto 6px',
              width: '24px',
              height: '24px',
              padding: 0,
              border: 'none',
              borderRadius: '7px',
              background: 'rgba(59, 130, 246, 0.12)',
              color: '#60a5fa',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              flexShrink: 0,
              transition: 'background 0.2s ease, color 0.2s ease'
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(59, 130, 246, 0.22)' }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(59, 130, 246, 0.12)' }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
              <line x1="12" y1="17" x2="12" y2="22"/>
              <path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>
            </svg>
          </button>
        )}

        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        <nav style={routerStyles.nav}>
          {navSections.map((section, sectionIndex) => (
            <div key={sectionIndex}>
              {sectionIndex > 0 && section.label && (
                <div style={{ margin: 0, height: '8px' }} />
              )}
              {section.label && (
                <div style={{
                  height: '14px',
                  padding: '0 22px 1px',
                  boxSizing: 'content-box',
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <div style={{
                    opacity: isExpanded ? 1 : 0,
                    transition: 'opacity 0.25s ease',
                    lineHeight: '14px',
                    whiteSpace: 'nowrap',
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    fontSize: '10.5px',
                    fontWeight: '600',
                    color: '#64748b',
                    letterSpacing: '0.07em',
                    textTransform: 'uppercase'
                  }}>
                    {section.label}
                  </div>
                  <div style={{
                    position: 'absolute',
                    left: '18px',
                    right: '18px',
                    top: '50%',
                    height: '1px',
                    backgroundColor: '#1b2438',
                    opacity: isExpanded ? 0 : 1,
                    transition: 'opacity 0.25s ease',
                    pointerEvents: 'none'
                  }} />
                </div>
              )}
              {section.items.map(pageId => {
                const page = pages.find(p => p.id === pageId)
                if (!page) return null
                const isActive = currentPage === page.id
                const isItemHovered = hoveredItem === page.id

                let navStyle
                if (isExpanded) {
                  navStyle = isActive ? routerStyles.navItemActiveExpanded : routerStyles.navItemExpanded
                } else {
                  navStyle = isActive ? routerStyles.navItemActive : routerStyles.navItem
                }

                if (isItemHovered && !isActive) {
                  navStyle = { ...navStyle, color: '#f1f5f9', backgroundColor: 'rgba(148, 163, 184, 0.08)' }
                }

                const iconColor = isActive ? '#60a5fa' : (isItemHovered ? '#f1f5f9' : '#cbd5e1')

                return (
                  <div
                    key={page.id}
                    onClick={() => handlePageClick(page)}
                    style={navStyle}
                    onMouseEnter={() => setHoveredItem(page.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    <span style={routerStyles.navIcon}>
                      <NavIcon name={page.id} color={iconColor} />
                    </span>
                    <div style={{
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      fontWeight: isActive ? '600' : '500',
                      opacity: isExpanded ? 1 : 0,
                      maxWidth: isExpanded ? '200px' : '0',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      transition: 'opacity 0.3s ease, max-width 0.3s ease',
                      fontSize: '13.5px',
                      letterSpacing: '-0.006em',
                      flex: 1
                    }}>
                      {page.label}
                    </div>
                    {isNewPage(page.id) && isExpanded && (
                      <span style={{
                        fontSize: '9px',
                        fontWeight: '800',
                        letterSpacing: '0.08em',
                        color: '#ffffff',
                        background: 'linear-gradient(135deg, #10b981 0%, #06b6d4 100%)',
                        padding: '2px 6px',
                        borderRadius: '999px',
                        textTransform: 'uppercase',
                        lineHeight: 1,
                        border: '1px solid rgba(255,255,255,0.18)',
                        flexShrink: 0
                      }}>NEW</span>
                    )}
                    {isNewPage(page.id) && !isExpanded && (
                      <span style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        background: '#10b981',
                        boxShadow: '0 0 6px rgba(16, 185, 129, 0.8)'
                      }} />
                    )}
                  </div>
                )
              })}
            </div>
          ))}
          {/* Resources Toggle */}
          <div>
            <div
              onClick={() => {
                const newVal = !resourcesOpen
                setResourcesOpen(newVal)
                localStorage.setItem('resources-open', String(newVal))
              }}
              onMouseEnter={() => setHoveredItem('resources')}
              onMouseLeave={() => setHoveredItem(null)}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: isExpanded ? '10px 12px' : '11px 0',
                margin: isExpanded ? '2px 10px' : '2px 8px',
                cursor: 'pointer',
                color: hoveredItem === 'resources' ? '#f1f5f9' : '#cbd5e1',
                backgroundColor: hoveredItem === 'resources' ? 'rgba(148, 163, 184, 0.08)' : 'transparent',
                transition: 'all 0.2s ease',
                borderRadius: '10px',
                userSelect: 'none',
                justifyContent: isExpanded ? 'flex-start' : 'center',
                gap: isExpanded ? '10px' : '0'
              }}
            >
              <span style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={hoveredItem === 'resources' ? '#f1f5f9' : '#cbd5e1'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                </svg>
              </span>
              <div style={{
                opacity: isExpanded ? 1 : 0,
                maxWidth: isExpanded ? '120px' : '0',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                transition: 'opacity 0.3s ease, max-width 0.3s ease',
                fontSize: '13px',
                fontWeight: '600',
                letterSpacing: '0.01em',
                flex: 1
              }}>
                Resources
              </div>
              <div style={{
                opacity: isExpanded ? 1 : 0,
                maxWidth: isExpanded ? '20px' : '0',
                overflow: 'hidden',
                transition: 'opacity 0.3s ease, max-width 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                transform: resourcesOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transitionProperty: 'opacity, max-width, transform'
              }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={hoveredItem === 'resources' ? '#f1f5f9' : '#cbd5e1'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </div>
            </div>

            <div style={{
              maxHeight: (isExpanded && resourcesOpen) ? '300px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease'
            }}>
              {resourcesItems.map(pageId => {
                const page = pages.find(p => p.id === pageId)
                if (!page) return null
                const isActive = currentPage === page.id
                const isItemHovered = hoveredItem === page.id
                let navStyle = isActive ? routerStyles.navItemActiveExpanded : routerStyles.navItemExpanded
                if (isItemHovered && !isActive) {
                  navStyle = { ...navStyle, color: '#f1f5f9', backgroundColor: 'rgba(148, 163, 184, 0.08)' }
                }
                const iconColor = isActive ? '#60a5fa' : (isItemHovered ? '#f1f5f9' : '#cbd5e1')
                return (
                  <div
                    key={page.id}
                    onClick={() => handlePageClick(page)}
                    style={{ ...navStyle, paddingLeft: '24px' }}
                    onMouseEnter={() => setHoveredItem(page.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    <span style={routerStyles.navIcon}>
                      <NavIcon name={page.id} color={iconColor} />
                    </span>
                    <div style={{ fontWeight: isActive ? '700' : '600', fontSize: '13px', letterSpacing: '0.01em' }}>
                      {page.label}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </nav>

        </div>

        {/* Bottom Section - Profile Icon & Action Buttons */}
        {user && (
          <div style={{
            borderTop: '1px solid #1b2438',
            paddingTop: '8px',
            paddingBottom: isExpanded ? '12px' : '8px'
          }}>
            {/* Pricing + Affiliates */}
            {bottomNavItems.map(pageId => {
              const page = pages.find(p => p.id === pageId)
              if (!page) return null
              const isActive = currentPage === page.id
              const isItemHovered = hoveredItem === page.id

              let navStyle
              if (isExpanded) {
                navStyle = isActive ? routerStyles.navItemActiveExpanded : routerStyles.navItemExpanded
              } else {
                navStyle = isActive ? routerStyles.navItemActive : routerStyles.navItem
              }
              if (isItemHovered && !isActive) {
                navStyle = { ...navStyle, color: '#f1f5f9', backgroundColor: 'rgba(148, 163, 184, 0.08)' }
              }
              const iconColor = isActive ? '#60a5fa' : (isItemHovered ? '#f1f5f9' : '#cbd5e1')

              return (
                <div
                  key={page.id}
                  onClick={() => handlePageClick(page)}
                  style={navStyle}
                  onMouseEnter={() => setHoveredItem(page.id)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <span style={routerStyles.navIcon}>
                    <NavIcon name={page.id} color={iconColor} />
                  </span>
                  <div style={{
                    fontWeight: isActive ? '700' : '600',
                    opacity: isExpanded ? 1 : 0,
                    maxWidth: isExpanded ? '200px' : '0',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    transition: 'opacity 0.3s ease, max-width 0.3s ease',
                    fontSize: '13px',
                    letterSpacing: '0.01em'
                  }}>
                    {page.label}
                  </div>
                </div>
              )
            })}
            {/* Settings/Profile Button */}
            {(() => {
              const isSettingsActive = currentPage === 'profile'
              const isSettingsHovered = hoveredItem === 'settings'
              const settingsColor = isSettingsActive ? '#60a5fa' : (isSettingsHovered ? '#f1f5f9' : '#cbd5e1')
              const settingsBg = isSettingsActive ? 'rgba(59, 130, 246, 0.12)' : (isSettingsHovered ? 'rgba(148, 163, 184, 0.08)' : 'transparent')

              return (
                <div
                  onClick={() => setCurrentPage('profile')}
                  onMouseEnter={() => setHoveredItem('settings')}
                  onMouseLeave={() => setHoveredItem(null)}
                  style={isExpanded ? {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 12px',
                    margin: '2px 10px 12px',
                    color: settingsColor,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    borderRadius: '10px',
                    backgroundColor: settingsBg,
                    fontSize: '13px',
                    fontWeight: isSettingsActive ? '700' : '600',
                    justifyContent: 'flex-start',
                    letterSpacing: '0.01em'
                  } : {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '11px 0',
                    margin: '2px 8px',
                    color: settingsColor,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    borderRadius: '10px',
                    backgroundColor: settingsBg,
                    fontSize: '18px'
                  }}
                >
                  <span style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <NavIcon name="settings" color={settingsColor} />
                  </span>
                  <div style={{
                    fontWeight: isSettingsActive ? '700' : '600',
                    opacity: isExpanded ? 1 : 0,
                    maxWidth: isExpanded ? '200px' : '0',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    transition: 'opacity 0.3s ease, max-width 0.3s ease',
                    color: settingsColor,
                    fontSize: '13px',
                    letterSpacing: '0.01em'
                  }}>
                    Settings
                  </div>
                </div>
              )
            })()}

            {/* Action Buttons - Only show when expanded */}
            <div style={{
              opacity: isExpanded ? 1 : 0,
              maxHeight: isExpanded ? '200px' : '0',
              overflow: 'hidden',
              transition: 'opacity 0.3s ease, max-height 0.3s ease',
              padding: '0 20px'
            }}>
              {(() => {
                const planColor = subscriptionTier === 'free' ? '#64748b' : subscriptionTier === 'sports' ? '#2563eb' : subscriptionTier === 'horse_racing' ? '#7c3aed' : '#16a34a'
                const planBorder = subscriptionTier === 'free' ? '#475569' : subscriptionTier === 'sports' ? '#3b82f6' : subscriptionTier === 'horse_racing' ? '#8b5cf6' : '#22c55e'
                return (
                  <div
                    onClick={() => subscriptionTier === 'free' ? setCurrentPage('pricing') : goToCustomerPortal()}
                    title={subscriptionTier === 'free' ? 'Upgrade Plan' : 'Manage Subscription'}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '7px 10px',
                      marginBottom: '8px',
                      borderRadius: '6px',
                      border: `1px solid ${planBorder}`,
                      backgroundColor: `${planColor}22`,
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = `${planColor}44`}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = `${planColor}22`}
                  >
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: planColor, flexShrink: 0 }} />
                    <div style={{
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#f1f5f9',
                      opacity: isExpanded ? 1 : 0,
                      maxWidth: isExpanded ? '160px' : '0',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      transition: 'opacity 0.3s ease, max-width 0.3s ease',
                      flex: 1
                    }}>
                      {TIER_NAMES[subscriptionTier] || 'Free Plan'}
                    </div>
                    <svg
                      width="12" height="12" viewBox="0 0 24 24" fill="none"
                      stroke="#94a3b8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                      style={{
                        opacity: isExpanded ? 1 : 0,
                        flexShrink: 0,
                        transition: 'opacity 0.3s ease'
                      }}
                    >
                      <polyline points="9 18 15 12 9 6"/>
                    </svg>
                  </div>
                )
              })()}
              <button
                onClick={() => signOut()}
                style={{
                  padding: '7px 4px',
                  backgroundColor: 'transparent',
                  color: '#8b97ab',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: isExpanded ? 'flex-start' : 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#ef4444'
                  e.currentTarget.querySelector('svg').style.stroke = '#ef4444'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#8b97ab'
                  e.currentTarget.querySelector('svg').style.stroke = '#8b97ab'
                }}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#8b97ab" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transition: 'stroke 0.2s ease' }}>
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                {isExpanded && 'Sign Out'}
              </button>

              {/* Social Icons */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                marginTop: '12px',
                paddingTop: '12px',
                paddingLeft: '8px',
                paddingRight: '8px',
                borderTop: '1px solid #1b2438'
              }}>
                {[
                  {
                    href: 'https://discord.gg/BV4dVEnx73',
                    title: 'Discord',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z"/>
                      </svg>
                    )
                  },
                  {
                    href: 'https://www.instagram.com/bookiecharity/',
                    title: 'Instagram',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                      </svg>
                    )
                  },
                  {
                    href: 'mailto:support@bookiecharity.com',
                    title: 'Email',
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                        <polyline points="22,6 12,13 2,6"/>
                      </svg>
                    )
                  }
                ].map(({ href, title, icon }) => (
                  <a
                    key={title}
                    href={href}
                    target={href.startsWith('mailto') ? '_self' : '_blank'}
                    rel="noopener noreferrer"
                    title={title}
                    style={{ color: '#64748b', transition: 'color 0.2s ease', display: 'flex', alignItems: 'center' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#f1f5f9'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
                  >
                    {icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Hover-expand overlays the content — the page never reflows */}
      <div style={routerStyles.content}>
        <div style={{ position: 'relative', minHeight: '100vh' }}>
          <div style={{ filter: (showPreview && currentPage !== 'ev' && currentPage !== 'odds' && currentPage !== 'arb' && currentPage !== 'middles' && currentPage !== 'bonus' && currentPage !== 'pickem' && currentPage !== 'racing' && currentPage !== 'prop_ev' && currentPage !== 'education' && currentPage !== 'bookmakers') ? 'blur(8px)' : 'none', transition: 'filter 0.2s ease', pointerEvents: (showPreview && currentPage !== 'ev' && currentPage !== 'odds' && currentPage !== 'arb' && currentPage !== 'middles' && currentPage !== 'bonus' && currentPage !== 'pickem' && currentPage !== 'racing' && currentPage !== 'prop_ev' && currentPage !== 'education' && currentPage !== 'bookmakers') ? 'none' : 'auto' }}>
            {allPageComponents}
          </div>
        </div>
      </div>

      {/* Preview Overlay - Rendered outside content for proper fixed positioning */}
      {showPreview && currentPage !== 'ev' && currentPage !== 'odds' && currentPage !== 'arb' && currentPage !== 'middles' && currentPage !== 'bonus' && currentPage !== 'pickem' && currentPage !== 'racing' && currentPage !== 'prop_ev' && currentPage !== 'education' && currentPage !== 'bookmakers' && (
        <PreviewOverlay
          featureName={previewFeature}
          hadTrial={hadTrial}
          onGotoPricing={() => {
            setShowPreview(false)
            setCurrentPage('pricing')
          }}
          onClose={() => {
            setShowPreview(false)
            setCurrentPage('dashboard')
          }}
        />
      )}
    </div>
  )

  // Main conditional rendering
  return (
    <div>
      {isPastDue && (
        <div
          style={{
            position: 'fixed',
            top: '12px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'calc(100% - 24px)',
            maxWidth: '720px',
            zIndex: 10000,
            background: 'rgba(220, 38, 38, 0.12)',
            backdropFilter: 'blur(16px) saturate(160%)',
            WebkitBackdropFilter: 'blur(16px) saturate(160%)',
            border: '1px solid rgba(248, 113, 113, 0.35)',
            borderRadius: '14px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
            color: '#fee2e2',
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '14px',
            fontSize: '13.5px',
            fontWeight: 500,
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Payment failed. Update your payment method to restore premium access.
          </span>
          <button
            onClick={goToCustomerPortal}
            style={{
              flexShrink: 0,
              background: 'rgba(248, 113, 113, 0.18)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              color: '#fee2e2',
              border: '1px solid rgba(248, 113, 113, 0.45)',
              borderRadius: '8px',
              padding: '7px 16px',
              fontSize: '13px',
              fontWeight: 700,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            Update payment
          </button>
        </div>
      )}

      {isMobile ? renderMobileLayout() : renderDesktopLayout()}

      <AuthModal
        isOpen={showAuthModal || isPasswordResetRequired}
        onClose={() => {
          // Don't allow closing if password reset is required
          if (!isPasswordResetRequired) {
            setShowAuthModal(false)
          }
        }}
      />

      {showUpgradePrompt && (
        <SimpleUpgradePrompt
          onClose={() => setShowUpgradePrompt(false)}
          onViewPlans={handleViewPlans}
        />
      )}
    </div>
  )
}

export default function PageRouter() {
  return (
    <AuthProvider>
      <PageRouterContent />
    </AuthProvider>
  )
}